module.exports = __webpack_public_path__ + "img/image-2.f550567e.svg";